import { render, staticRenderFns } from "./shipping-info.vue?vue&type=template&id=5f879dd1&scoped=true"
import script from "./shipping-info.vue?vue&type=script&lang=js"
export * from "./shipping-info.vue?vue&type=script&lang=js"
import style0 from "./shipping-info.vue?vue&type=style&index=0&id=5f879dd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f879dd1",
  null
  
)

export default component.exports